module.exports = __webpack_public_path__ + "img/img-a4e2c0.png";